module.exports = __webpack_public_path__ + "img/winternis.a48639eb.jpg";